import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1240px] mx-auto px-6 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="/" className="flex items-center">
          <img
            src="https://storage.readdy-site.link/project_files/26e3b86f-cc28-43d6-ae72-d910dd967b3f/1d15724a-ec62-4ee1-9e78-2a32eb541b2d_logo_fd_NoBG.png?v=2eb01d7e8656ed8da8e114c01d14912f"
            alt="株式会社FD"
            className={`h-10 w-auto object-contain transition-all duration-300 ${scrolled ? "" : "brightness-0 invert"}`}
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {[
            { jp: "会社概要", en: "About", href: "/about" },
            { jp: "事業案内", en: "Service", href: "/service" },
            { jp: "お知らせ", en: "News", href: "/news" },
            { jp: "お問い合わせ", en: "Contact", href: "/contact" },
          ].map((item) => (
            <Link
              key={item.en}
              to={item.href}
              className={`flex flex-col items-center text-xs leading-tight transition-colors cursor-pointer hover:text-[#3ab5c6] ${
                scrolled ? "text-gray-700" : "text-white"
              }`}
            >
              <span className="text-[11px]">{item.jp}</span>
              <span className="font-['Poppins'] font-medium text-[11px] tracking-wider">{item.en}</span>
            </Link>
          ))}
          <Link
            to="/recruit"
            className="ml-4 bg-[#3ab5c6] text-white text-xs px-5 py-2 rounded-full whitespace-nowrap hover:bg-[#2da0b0] transition-colors cursor-pointer"
          >
            採用情報はこちら！
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className={`block w-6 h-0.5 transition-all ${scrolled ? "bg-gray-700" : "bg-white"}`}></span>
          <span className={`block w-6 h-0.5 transition-all ${scrolled ? "bg-gray-700" : "bg-white"}`}></span>
          <span className={`block w-6 h-0.5 transition-all ${scrolled ? "bg-gray-700" : "bg-white"}`}></span>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-lg px-6 py-6 flex flex-col gap-4">
          {[
            { jp: "会社概要", en: "About", href: "/about" },
            { jp: "事業案内", en: "Service", href: "/service" },
            { jp: "お知らせ", en: "News", href: "/news" },
            { jp: "お問い合わせ", en: "Contact", href: "/contact" },
          ].map((item) => (
            <Link
              key={item.en}
              to={item.href}
              onClick={() => setMenuOpen(false)}
              className="text-gray-700 text-sm hover:text-[#3ab5c6] cursor-pointer"
            >
              {item.jp}
              <span className="ml-2 text-xs text-gray-400 font-['Poppins']">{item.en}</span>
            </Link>
          ))}
          <Link
            to="/recruit"
            onClick={() => setMenuOpen(false)}
            className="bg-[#3ab5c6] text-white text-sm px-5 py-2 rounded-full text-center whitespace-nowrap hover:bg-[#2da0b0] transition-colors cursor-pointer"
          >
            採用情報はこちら！
          </Link>
        </div>
      )}
    </header>
  );
}
